let base_path = window.RUNTIME_API_HOST
  ? window.RUNTIME_API_HOST
  : process.env.REACT_APP_HOST;

export const route = {
  // Create partner agreement
  CREATE: `${base_path}/partnerAgreement/create`,
  SAVE_COMMITMENT: `${base_path}/partnerCommitment/create`,

  // Send message to partner
  SEND_MESSAGE_TO_PARTNER: (id) =>
    `${base_path}/email/send_after_sign_agreement/${id}`,

  // Send message to internal ceo
  SEND_MESSAGE_TO_INTERNAL_CEO: (id) =>
    `${base_path}/email/send_internal_message_after_sign_agreement/${id}`,

  // Download partner agreement pdf
  DOWNLOAD_PDF: (email) => {
    if (email !== null && email !== undefined && email !== '')
      return `${base_path}/partnerAgreement/download/${email}`;
    else return false;
  },

  // Download partner agreement pdf
  DOWNLOAD_COMMITMENT_PDF: (email) => {
    if (email !== null && email !== undefined && email !== '')
      return `${base_path}/partnerCommitment/download/${email}`;
    else return "#";
  },

  // Download empty pdf
  DOWNLOAD_EMPTY_PDF: (commissionRate) => {
    if (commissionRate > 0)
      return `${base_path}/partnerAgreement/download/empty/${commissionRate}`;
    else return "#";
  },

  // Fetch States
  FETCH_STATES: `${base_path}/geographic/states`,

  // Prefill from the Monday item id carried in the sign-up link (was HubSpot-based)
  FETCH_PARTNER_PREFILL: (id) => `${base_path}/partnerAgreement/prefill/${id}`,

  // Preview-opened tracking (Monday counters) — step is "agreement" or "commitment"
  TRACK_PREVIEW: (step, id) => `${base_path}/partnerAgreement/track/preview/${step}/${id}`,
};



// WEBPACK FOOTER //
// ./src/modules/AppCore/constants/API.Routes.js